import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { Logo } from '../../../components/Logo';
import style from './style';

const LoginHead = (): JSX.Element =>  {
  const { t: translate } = useTranslation();

  return (
    <>
      <Box sx={ style.box.sx }>
        <Logo />
        <Typography variant={ style.title.variant } sx={ style.title.sx }>
          {translate(STRING_KEYS.LOGIN_TITLE)}
        </Typography>
        <Typography
          color={ style.description.color }
          sx={ style.description.sx }
          variant={ style.description.variant }
        >
          {translate(STRING_KEYS.LOGIN_DESCRIPTION)}
        </Typography>
      </Box>
    </>
  );
};

export default LoginHead;
